<template>
    <div id="Custommade">
        <Nav />
        <Banner :url="bannerurl" :showBtn="true"/>
        <div class="peixun"></div>
        <div class="company_friend">
            <div>
                <p class="title">合作企业</p>
                <p class="sub_title">多变合作促进共同繁荣</p>
                <img src="../../static/images/companyFriend_bg.png" alt="" style="margin-top: 40px;width: 80%">
            </div>
        </div>
        <Contact />
    </div>
</template>

<script>
    import Nav from '@/components/common/nav'
    import Banner from '@/components/common/banner'
    import Content from '@/components/common/content'
    import FooterContent from '@/components/common/footerContent'
    import Contact from '@/components/common/contact'
    export default {
        name: "Custommade",
        data(){
            return{
                bannerurl:'../../../static/images/custommade_banner.jpg',
                styles:{
                    'padding-bottom':'100px'
                }
            }
        },
        methods:{
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop <= 0) {
                    document.getElementsByClassName('navbar-inverse')[0].removeAttribute('style')
                } else {
                    document.getElementsByClassName('navbar-inverse')[0].setAttribute('style','background:#262626')
                }
            }
        },
        components: {
            Nav,
            Banner,
            Content,
            FooterContent,
            Contact
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style scoped lang="scss">
.peixun{
    width: 100%;
    height: 700px;
    background: url("../../static/images/peixun.png") no-repeat center center;
    background-size: 60%;
}
.company_friend{
    width: 100%;
    height: 600px;
    background: url("../../static/images/company_friend.jpg") no-repeat center center;
    text-align: center;
    .title{
        padding-top: 80px;
        font-size: 52px;
        color: #fff;
    }
    .sub_title{
        color: #deecef;
        font-size: 38px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Custommade.vue